import UrlParams from 'commons/js/util/UrlTo/UrlParams'

const buildPOI = (value, label) => {
    return value && label ? { value, label } : null
}

const isTrue = (value) => /true/.test(value)

export const getSearchParams = () => {
    const queryParams = new UrlParams()
    queryParams.loadFromUrl()
    const {
        start_date: startDate,
        end_date: endDate,
        isMutuaUser,
        share,
        age,
        vehicleType,
        isDifferentReturnLocation,
        idOriginPOI,
        titleOriginPOI,
        idDestinationPOI,
        titleDestinationPOI,
        isCancelled,
        pickUpInputSearch,
        returnPlaceInputSearch,
    } = queryParams.params

    return {
        startDate,
        endDate,
        share,
        isMutuaUser: isTrue(isMutuaUser),
        age,
        vehicleType,
        isDifferentReturnLocation: isTrue(isDifferentReturnLocation),
        pickUpPlace: buildPOI(idOriginPOI, titleOriginPOI),
        pickUpInputSearch,
        returnUpPlace: buildPOI(idDestinationPOI, titleDestinationPOI),
        returnPlaceInputSearch,
        isCancelled: isTrue(isCancelled),
    }
}
